import { ActionTypesScreen2 } from "app/constants";

const defaultJobType = "All Jobs"

export const defaultState = {
  listData: [],
  objectData: {},
  singleData: null,
  jobTypeSelectedS2: defaultJobType
};

function Screen2Reducer(state = defaultState, action) {
    switch (action.type) {
      case ActionTypesScreen2.GET_AVERAGE_DATA:
        return { ...state, averageData: action.payload }
      case ActionTypesScreen2.GET_COUNT_DATA:
        return { ...state, countData: action.payload }
      case ActionTypesScreen2.GET_PERCENT_DATA:
        return { ...state, percentData: action.payload }
      case ActionTypesScreen2.GET_GROWTH_DATA:
        return { ...state, growthData: action.payload }
      case ActionTypesScreen2.SET_SELECTED_JOB_TYPE_S2:
        return { ...state, jobTypeSelectedS2: action.payload }
      default:
        return state;
    }
  }
  
  export default Screen2Reducer;